
import Layout from "../components/Layout";
import { ListadoSolicitud } from '../components/ListadoSolicitud/ListadoSolicitud';

const ListaSolicitud = () => {
    return (
        <>      
        <Layout/>
        <ListadoSolicitud/>
        </>
    );
}

export default ListaSolicitud;   
